const state = {
  lines: [
    {
      code: "west",
      title: "Metro West"
    },
    {
      code: "greaterWest",
      title: "Greater West"
    },
    {
      code: "northWest",
      title: "NorthWest"
    },
    {
      code: "citySouthWest",
      title: "City and SouthWest"
    },
    {
      code: "futureProjects",
      title: "Future Projects"
    }
  ],
  stations: {
    west: [
      "Example Station X",
      "Pyrmont",
      "The Bays Precinct",
      "Five Dock",
      "Burwood North",
      "North Strathfield",
      "Olympic Park",
      "Silverwater",
      "Clyde",
      "Parramatta",
      "Westmead"
    ],
    greaterWest: [],
    northWest: [],
    citySouthWest: [],
    futureProjects: []
  },
  selectedLine: {},
  selectedStations: [],
  zones: [
    {
      code: "commercial",
      title: "Commercial",
      icon: "img/icons/projectIcon/commercial_icon.png",
      path: "/commercial"
    },
    {
      code: "reporting",
      title: "Reporting",
      icon: "img/icons/projectIcon/report_icon.png",
      path: "/reporting"
    },
    {
      code: "design",
      title: "Design",
      icon: "img/icons/projectIcon/design_icon.png",
      path: "/design"
    },
    {
      code: "collaboration",
      title: "Collaboration",
      icon: "img/icons/projectIcon/collab_icon.png",
      path: "/collaboration"
    },
    {
      code: "management",
      title: "Management",
      icon: "img/icons/projectIcon/management_icon.png",
      path: "/management"
    },
    {
      code: "innovation",
      title: "Research and Innovation",
      icon: "img/icons/projectIcon/innovation_icon.png",
      path: "/innovation"
    },
  ],
  categories: {
    commercial: [
      "Cost (Capex)",
      "Cost (Opex)",
      "Procurement and Supply Chain",
      "Contract"
    ],
    reporting: [
      "Monthly",
      "Weekly",
      "Live"
    ],
    design: [
      "Source Records",
      "Design Inputs",
      "Preliminary Design",
      "Detailed Design",
      "IFC",
      "CPS",
      "As-Builts",
      "Handover"
    ],
    collaboration: [
      "Correspondence Management",
      "File Transfer",
      "Contact List",
      "Meetings",
      "Action Lists",
      "Risk and Issue Management",
      "Document Management",
      "Shared Calendar",
      "Interface Management",
      "Stakeholder Management"
    ],
    management: [
      "Management Plans",
      "Passport (Inductions)",
      "Resource Management",
      "Planning and Scheduling",
      "Change Control",
      "Health and Safety"
    ],
    innovation: [
      "Innovation"
    ]
  },
  selectedZone: {},
  selectedCategories: [],
  counter: 0,
  activeTabFlags: {
    insightSection: false,
    bim360Section: false,
    GISDashboardSection: false,
    GISPortalSection: false,
    simulationSection: false,
    opsSection: false,
    teamBinderSection: false
  },
  portfolios: [
    {
      code: "portfolio",
      title: "Portfolio"
    }
    // {
    //   code: "passenger_service",
    //   title: "Passenger Services"
    // },
    // {
    //   code: "other_lines",
    //   title: "Other Lines"
    // },
    // {
    //   code: "closed_lines",
    //   title: "Closed Lines"
    // },

  ],
  projects: {
    portfolio: [
      "Tottenham to Albury (T2A)",
      "Albury to Illabo (A2I)",
      "Illabo to Stockinbingal (I2S)",
      "Stockinbingal to Parkes (S2P)",
      "Parkes to Narromine (P2N)",
      "Narromine to Narrabri (N2N)",
      "Narrabri to North Star (N2NS)",
      "North Star to Border (NS2B)",
      "Border to Gowrie (B2G)",
      "Gowrie to Helidon (G2H)",
      "Helidon to Calvert (H2C)",
      "Calvert to Kaguru (C2K)",
      "Kaguru to Acacia Ridge / Bromelton (K2AR)"
    ]
    // passenger_service: [
    //   "Muswellbrook",
    //   "Station A",
    //   "Station B",
    //   "Station C",
    //   "Station D"
    // ],
    // other_lines: [
    //   "Station E",
    //   "Station F",
    //   "Station G",
    //   "Station H",
    //   "Station I"
    // ],
    // closed_lines: [
    //   "Station J",
    //   "Station K",
    //   "Station L",
    //   "Station M",
    //   "Station N"
    // ]
  },
  projectTabs: [
    {
      zoneCode: "commercial",
      items: [
        {
          category: "Cost (Capex)",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "Cost (Opex)",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "Procurement and Supply Chain",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "Contract",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        }
      ]
    },
    {
      zoneCode: "reporting",
      items: [
        {
          category: "Monthly",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "Weekly",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "Live",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
      ]
    },
    {
      zoneCode: "design",
      items: [
        {
          category: "Requirements",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "Reports & Deliverables",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "Design Models",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "Sustainability",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "Source Records",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "Design Inputs",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "Preliminary Design",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "Detailed Design",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "IFC",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "CPS",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "As-Builts",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "Handover",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
      ]
    },
    {
      zoneCode: "collaboration",
      items: [
        {
          category: "Correspondence Management",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "File Transfer",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "Contact List",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "Meetings",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "Action Lists",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "Risk and Issue Management",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "Document Management",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "Shared Calendar",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "Interface Management",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "Stakeholder Management",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        }
      ]
    },
    {
      zoneCode: "management",
      items: [
        {
          category: "Management Plans",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "Passport (Inductions)",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "Resource Management",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "Planning and Scheduling",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "Change Control",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
        {
          category: "Health and Safety",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        },
      ]
    },
    {
      zoneCode: "innovation",
      items: [
        {
          category: "Innovation",
          tabs: [
            {
              title: "PROJECT MANAGEMENT",
              url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "DESIGN PORTAL",
              url: "img/assets/tabs/DesignPortalTab.png"
            },
            {
              title: "INFORMATION EXCHANGE",
              url: "img/assets/tabs/InformationExchangeTab1.png"
            }
          ]
        }
      ]
    }
  ],
  selectedPortfolio: {},
  selectedProjects: [],
  currentSelectedProject: "",
  currentSelectedSubCategory: "",
  currentSelectedProjectTab: {
    category: "",
    tabs: [
    ]
  }
}

function initialState() {
  return {
    lines: [
      {
        code: "west",
        title: "Metro West"
      },
      {
        code: "greaterWest",
        title: "Greater West"
      },
      {
        code: "northWest",
        title: "NorthWest"
      },
      {
        code: "citySouthWest",
        title: "City and SouthWest"
      },
      {
        code: "futureProjects",
        title: "Future Projects"
      }
    ],
    stations: {
      west: [
        "Example Station X",
        "Pyrmont",
        "The Bays Precinct",
        "Five Docks",
        "Burwood North",
        "North Strathfield",
        "Olympic Park",
        "Silverwater",
        "Clyde",
        "Paramatta",
        "Westmead"
      ],
      greaterWest: [],
      northWest: [],
      citySouthWest: [],
      futureProjects: []
    },
    selectedLine: {},
    selectedStations: [],
    zones: [
      {
        code: "commercial",
        title: "Commercial",
        icon: "img/icons/projectIcon/commercial_icon.png",
        path: "/commercial"
      },
      {
        code: "reporting",
        title: "Reporting",
        icon: "img/icons/projectIcon/report_icon.png",
        path: "/reporting"
      },
      {
        code: "design",
        title: "Design",
        icon: "img/icons/projectIcon/design_icon.png",
        path: "/design"
      },
      {
        code: "collaboration",
        title: "Collaboration",
        icon: "img/icons/projectIcon/collab_icon.png",
        path: "/collaboration"
      },
      {
        code: "management",
        title: "Management",
        icon: "img/icons/projectIcon/management_icon.png",
        path: "/management"
      },
      {
        code: "innovation",
        title: "Research and Innovation",
        icon: "img/icons/projectIcon/innovation_icon.png",
        path: "/innovation"
      },
    ],
    categories: {
      commercial: [
        "Cost (Capex)",
        "Cost (Opex)",
        "Procurement and Supply Chain",
        "Contract"
      ],
      reporting: [
        "Monthly",
        "Weekly",
        "Live"
      ],
      design: [
        "Source Records",
        "Design Inputs",
        "Preliminary Design",
        "Detailed Design",
        "IFC",
        "CPS",
        "As-Builts",
        "Handover"
      ],
      collaboration: [
        "Correspondence Management",
        "File Transfer",
        "Contact List",
        "Meetings",
        "Action Lists",
        "Risk and Issue Management",
        "Document Management",
        "Shared Calendar",
        "Interface Management",
        "Stakeholder Management"
      ],
      management: [
        "Management Plans",
        "Passport (Inductions)",
        "Resource Management",
        "Planning and Scheduling",
        "Change Control",
        "Health and Safety"
      ],
      innovation: [
        "Innovation"
      ]
    },
    selectedZone: {},
    selectedCategories: [],
    counter: 0,
    activeTabFlags: {
      insightSection: false,
      bim360Section: false,
      GISDashboardSection: false,
      GISPortalSection: false,
      simulationSection: false,
      opsSection: false,
      teamBinderSection: false
    },
    portfolios: [
      {
        code: "portfolio",
        title: "Portfolio"
      }
      // {
      //   code: "passenger_service",
      //   title: "Passenger Services"
      // },
      // {
      //   code: "other_lines",
      //   title: "Other Lines"
      // },
      // {
      //   code: "closed_lines",
      //   title: "Closed Lines"
      // },

    ],
    projects: {
      portfolio: [
        "Tottenham to Albury (T2A)",
        "Albury to Illabo (A2I)",
        "Illabo to Stockinbingal (I2S)",
        "Stockinbingal to Parkes (S2P)",
        "Parkes to Narromine (P2N)",
        "Narromine to Narrabri (N2N)",
        "Narrabri to North Star (N2NS)",
        "North Star to Border (NS2B)",
        "Border to Gowrie (B2G)",
        "Gowrie to Helidon (G2H)",
        "Helidon to Calvert (H2C)",
        "Calvert to Kaguru (C2K)",
        "Kaguru to Acacia Ridge / Bromelton (K2AR)"
      ]
      // passenger_service: [
      //   "Muswellbrook",
      //   "Station A",
      //   "Station B",
      //   "Station C",
      //   "Station D"
      // ],
      // other_lines: [
      //   "Station E",
      //   "Station F",
      //   "Station G",
      //   "Station H",
      //   "Station I"
      // ],
      // closed_lines: [
      //   "Station J",
      //   "Station K",
      //   "Station L",
      //   "Station M",
      //   "Station N"
      // ]
    },
    projectTabs: [
      {
        zoneCode: "commercial",
        items: [
          {
            category: "Cost (Capex)",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "Cost (Opex)",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "Procurement and Supply Chain",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "Contract",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          }
        ]
      },
      {
        zoneCode: "reporting",
        items: [
          {
            category: "Monthly",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "Weekly",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "Live",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
        ]
      },
      {
        zoneCode: "design",
        items: [
          {
            category: "Requirements",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "Reports & Deliverables",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "Design Models",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "Sustainability",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "Source Records",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "Design Inputs",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "Preliminary Design",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "Detailed Design",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "IFC",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "CPS",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "As-Builts",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "Handover",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
        ]
      },
      {
        zoneCode: "collaboration",
        items: [
          {
            category: "Correspondence Management",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "File Transfer",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "Contact List",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "Meetings",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "Action Lists",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "Risk and Issue Management",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "Document Management",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "Shared Calendar",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "Interface Management",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "Stakeholder Management",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          }
        ]
      },
      {
        zoneCode: "management",
        items: [
          {
            category: "Management Plans",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "Passport (Inductions)",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "Resource Management",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "Planning and Scheduling",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "Change Control",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
          {
            category: "Health and Safety",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          },
        ]
      },
      {
        zoneCode: "innovation",
        items: [
          {
            category: "Innovation",
            tabs: [
              {
                title: "PROJECT MANAGEMENT",
                url: "https://app.powerbi.com/reportEmbed?reportId=cd9472b1-8de3-449b-b984-755555f9c879&appId=567561fa-e479-457a-a156-416aaf09a532&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
              },
              {
                title: "DESIGN PORTAL",
                url: "img/assets/tabs/DesignPortalTab.png"
              },
              {
                title: "INFORMATION EXCHANGE",
                url: "img/assets/tabs/InformationExchangeTab1.png"
              }
            ]
          }
        ]
      }
    ],
    selectedPortfolio: {},
    selectedProjects: [],
    currentSelectedProject: "",
    currentSelectedSubCategory: "",
    currentSelectedProjectTab: {
      category: "",
      tabs: [
      ]
    }
  }
}

const mutations = {
  upCounter(state) {
    state.counter += 1
  },
  setSelectedZone(state, payload) {
    var selectedZone = state.zones.filter(obj=>obj.code == payload)[0]
    state.selectedZone = selectedZone
  },
  setCategoriesFromZone(state, payload) {
    var categories = state.categories[payload]
    state.selectedCategories = categories
  },
  setSelectedLine(state, payload) {
    var selectedLine = state.lines.filter(obj=>obj.code == payload)[0]
    state.selectedLine = selectedLine
    console.log(selectedLine);
  },
  setSelectedStations(state, payload) {
    state.selectedStations = state.stations[payload]
  },
  setActiveTabFlags(state, payload) {
    state.activeTabFlags[payload] = true
  },
  setSelectedPortfolio(state, payload) {
    var selectedPortfolio = state.portfolios.filter(obj=>obj.code == payload)[0]
    state.selectedPortfolio = selectedPortfolio
  },
  setSelectedProjects(state, payload) {
    state.selectedProjects = state.projects[payload]
  },
  setCurrentSelectedSubCategory(state, payload) {
    state.currentSelectedSubCategory = payload
  },
  setCurrentSelectedProject(state, payload) {
    state.currentSelectedProject = payload
  },
  setCurrentSelectedProjectTab(state, payload) {
    state.currentSelectedProjectTab = payload
  },
}

const actions = {

}

const getters = {

}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
